module.exports = __webpack_public_path__ + "static/services-20b34c99b2063ed3161bd0919c4376d3.png";